import { Page } from "../components/ui";
import ListTeams from "../components/sidekick/teams/ListTeams";

function TeamAdmin() {
  return (
    <Page>
      <ListTeams />
    </Page>
  );
}

export default TeamAdmin;
